import { useRouter } from 'next/router';

import CategoryPage from '~/src/common/components/Category/Page/Page';
import { withEnhancedGSSP } from '~/src/common/services/Networking/server/withEnhancedGSSP';
import { getCategory, getGetCategoryQueryKey } from '~/src/queries/api-ecom/generated/api-ecom';

const Page = () => {
  const { query } = useRouter<{ categorySlug: string }>();
  return <CategoryPage slug={query.categorySlug} />;
};

export default Page;

const getCategoryPrefetchParams = (slug: string) => {
  const queryKey = getGetCategoryQueryKey(slug);
  const queryFn = () => getCategory(slug);
  return [queryKey, queryFn] as const;
};

export const getServerSideProps = withEnhancedGSSP(async ({ query }, { prefetch, redirect }) => {
  // Le slug de la catégorie courante
  const slug = String(query.categorySlug);

  // Chargement de la catégorie
  const category = await prefetch(...getCategoryPrefetchParams(slug));

  // SC-10309 : Rediriger la catégorie `Home` vers la racine du site
  if (category.tags?.some(tag => tag === 'Home')) redirect('/');
  // Si la catégorie est une catégorie recette (sous-catégorie de la catégorie nos recettes), on redirige vers l'url d'une page de catégorie recette
  if (category.parent?.slug === 'nos-recettes') redirect(`/recette/categorie/${category.slug}`);
  // Si la catégorie est la catégorie racine des recettes, on redirige vers la page principale des recettes
  if (category.slug === 'nos-recettes') redirect(`/recette`);
  // SC-11249 : Rediriger la catégorie vers son url la plus récente
  if (category.slug !== slug) redirect(`/categorie/${category.slug}`);

  // Chargement des 2 premières sous-catégories non vides
  const subcats = category.subcategories.filter(c => c.itemCount);
  const subslugs = subcats.slice(0, 2).map(subcategory => subcategory.slug);
  await Promise.all(subslugs.map(subslug => prefetch(...getCategoryPrefetchParams(subslug))));
});
